module.exports = __webpack_public_path__ + "img/box-afro.669aa246.png";